var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VideoLiveForDesktop'),_c('div',{staticClass:"submachine-hide-on-mobile"},[_c('TableResult',{attrs:{"rows":6,"cols":35}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }